import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/trafficbuilders.webp';
import screenshot_target from '../../../images/letterfunnel/woltertjeenkwillink.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Wolter Tjeenk Willink"
      firstname="Wolter"
      companyname="Traffic Builders"
      competition="OrangeValley en SDIM"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/woltertjeenkwillink.js